import axios from '../common/axios';

export type Version = {
  gitHash: string;
};

async function getVersion(): Promise<Version> {
  return axios.get('service/version').then((res) => res.data);
}

export { getVersion };
